<!-- Se for a rota /intro, exibe apenas o layout da intro -->
@if (isIntroRoute) {
<div class="argon-home-fullscreen">
  <router-outlet></router-outlet>
</div>
} @else {
<app-header [descHeader]="title()"></app-header>
<!-- Define se usa layout com side menu ou layout simples -->
@if (showFullLayout()) {
<div class="main-container">
  <app-spinner></app-spinner>
  <app-side-menu></app-side-menu>
  <div class="content">
    <app-toast></app-toast>
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
} @else {
<div class="argon-home-fullscreen">
  <router-outlet></router-outlet>
</div>
}
<!-- Layout simplificado (sem menu) -->
}

<!-- Caso contrário, renderiza o app completo -->